import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  commission: null,
  singleCommission: null,
};

export const CommissionSlice = createSlice({
  name: "CommissionSlice",
  initialState,
  reducers: {
    setCommission: (state, { payload }) => {
      state.commission = payload;
      console.log(payload, "@all payload commission");
    },
    setNewCommission: (state, { payload }) => {
      state.commission.commissions.push(payload);
      console.log(payload, "@all payload commission");
    },
    setDefaultCommission: (state, { payload }) => {
      state.commission.commissions = payload;
      console.log(payload, "@default payload commission");
    },
    setSingle: (state, { payload }) => {
      state.singleCommission = payload;
      console.log(payload, "@all payload commission");
    },
    setUpdateCommission: (state, { payload }) => {
      console.log(payload, "@commission payload");
      if (state.commission?.commissions?.length > 0) {
        state.commission.commissions = state.commission.commissions.map(
          (item) => {
            if (item._id === payload?._id) {
              return { ...item, ...payload };
            }
            return item;
          }
        );
      }
    },
    setDeleteCommission: (state, { payload }) => {
      console.log(payload, "@commission payload");
      state.commission.commissions = state.commission.commissions.filter(
        (item) => item._id !== payload?._id
      );
    },
  },
});

export const {
  setCommission,
  setUpdateCommission,
  setDeleteCommission,
  setSingle,
  setNewCommission,
  setDefaultCommission,
} = CommissionSlice.actions;
export default CommissionSlice.reducer;
